import { api } from "@/api";
import { ChangeLogRecord } from "@/api/change-logs/change-logs";
import { setChangeLogModal } from "@/app/store/user/reducer";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";
import { useEffect } from "react";

function ChangeLogItem({ record }: { record: ChangeLogRecord }) {
  return (
    <div className="flex flex-col">
      <span className="text-sm font-semibold">{record.version}</span>
      <span className="text-sm text-default-500">
        {new Date(record.created_at).toLocaleDateString()}
      </span>
      <span
        className="text-sm text-default-500 mt-2"
        dangerouslySetInnerHTML={{
          __html: record.description.replace(/\n/g, "<br />"),
        }}
      />
    </div>
  );
}

export default function ChangeLogModal() {
  const disclosure = useDisclosure();
  const state = useAppSelector((state) => state.user.modals.changeLog);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (state.isOpen) {
      disclosure.onOpen();
    } else {
      disclosure.onClose();
    }
  }, [state.isOpen, disclosure]);

  useEffect(() => {
    if (!disclosure.isOpen) {
      dispatch(setChangeLogModal(false));
    } else {
      const lastLogId = state.records[0]?.id;
      api.changeLogs.markAsRead(lastLogId);
    }
  }, [disclosure.isOpen, dispatch, state.records]);

  return (
    <>
      <Modal
        isOpen={disclosure.isOpen}
        onClose={disclosure.onClose}
        title="Журнал обновлений"
        backdrop="blur"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>
                <span className="text-lg font-bold">Журнал обновлений</span>
              </ModalHeader>
              <ModalBody>
                <div className="flex flex-col gap-2 max-h-[500px] overflow-y-auto">
                  {state.records.map((record, index) => (
                    <>
                      <ChangeLogItem key={record.id} record={record} />
                      {index !== state.records.length - 1 && <Divider />}
                    </>
                  ))}
                </div>
              </ModalBody>
              <ModalFooter>
                <Button onPress={onClose}>Закрыть</Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
